'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["elementData", "didDrop", "dropItem", "label", "translatedLabel", "disabled", "isLocked", "showBetaRibbon"],
  _excluded2 = ["withStoringInRecentlyUsed"];
import { connect } from 'react-redux';
import { Component } from 'react';
import PropTypes from 'prop-types';
import WidgetIcon from 'ContentComponents/components/cmv2/WidgetIcon';
import { getIconOverride, getIsNewModule, getIsBetaModule } from 'EmailEditorUI/utils/moduleUtils';
import { MODULE_ICON_MAX_SIZE } from 'EmailEditorUI/constants/SidebarConstants';
import { getTranslatedModuleLabel, getRecentlyUsedModulesIds } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import storeInRecentlyUsedModules from 'LayoutBuilderUI/utils/storeInRecentlyUsedModules';
import withDraggableElement from 'LayoutBuilderUI/hoc/withDraggableElement';
import DraggableTile from './DraggableTile';
import { jsx as _jsx } from "react/jsx-runtime";
class BaseElementTile extends Component {
  getIcon() {
    const {
      elementData,
      disabled,
      isLocked
    } = this.props;
    const override = getIconOverride(elementData.moduleId, elementData.name);
    if (override) {
      if (override.isIcon) {
        const {
          ModuleIcon,
          dataTestId
        } = override;
        return /*#__PURE__*/_jsx(ModuleIcon, {
          color: disabled || isLocked ? 'icon-primary-disabled' : 'icon-core-subtle',
          "data-test-id": dataTestId,
          size: "600"
        });
      }
    }
    return /*#__PURE__*/_jsx(WidgetIcon, {
      size: MODULE_ICON_MAX_SIZE,
      icon: elementData.icon,
      color: disabled || isLocked ? 'icon-primary-disabled' : 'icon-core-subtle'
    });
  }
  render() {
    const _this$props = this.props,
      {
        elementData,
        didDrop,
        dropItem,
        label,
        translatedLabel,
        disabled,
        isLocked,
        showBetaRibbon
      } = _this$props,
      otherProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const didDropThis = didDrop && this.props.elementData === dropItem.moduleSpec;
    return /*#__PURE__*/_jsx(DraggableTile, Object.assign({
      disabled: disabled,
      icon: this.getIcon(),
      label: label || translatedLabel,
      "data-test-id": "module-tile",
      "data-module-name": elementData.name,
      "data-module-id": elementData.moduleId,
      didDrop: didDropThis,
      isNew: getIsNewModule(elementData.moduleId),
      isBeta: showBetaRibbon || getIsBetaModule(elementData.moduleId),
      isLocked: isLocked
    }, otherProps));
  }
}
BaseElementTile.propTypes = {
  elementData: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  translatedLabel: PropTypes.string,
  isLocked: PropTypes.bool,
  showBetaRibbon: PropTypes.bool,
  // react-dnd
  didDrop: PropTypes.bool.isRequired,
  dropItem: PropTypes.object,
  recentlyUsedModulesIds: PropTypes.array.isRequired,
  withStoreInRecentlyUsedModules: PropTypes.bool,
  innerRef: PropTypes.shape({
    current: PropTypes.instanceOf(Element)
  })
};
BaseElementTile.defaultProps = {
  elementData: {}
};
const mapStateToProps = (state, props) => {
  return {
    translatedLabel: getTranslatedModuleLabel(state, props.elementData.name, props.elementData.moduleId),
    recentlyUsedModulesList: getRecentlyUsedModulesIds(state)
  };
};
const DraggableElementTile = withDraggableElement(BaseElementTile);
const DraggableRecentlyUsedElementTile = withDraggableElement(BaseElementTile, storeInRecentlyUsedModules);
const ElementTile = _ref => {
  let {
      withStoringInRecentlyUsed
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded2);
  if (withStoringInRecentlyUsed) {
    return /*#__PURE__*/_jsx(DraggableRecentlyUsedElementTile, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsx(DraggableElementTile, Object.assign({}, props));
};
export default connect(mapStateToProps)(ElementTile);